import { defineComponent as d, openBlock as t, createElementBlock as l, mergeProps as u, unref as o, renderSlot as i, createElementVNode as e, createCommentVNode as m } from "vue";
import { useScalarIcon as p } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, h = { key: 1 }, g = { key: 2 }, M = { key: 3 }, f = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconPlusMinus"
}, A = /* @__PURE__ */ d({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const r = s, { bind: H, weight: n } = p(r);
    return (V, a) => (t(), l("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(H)), [
      i(V.$slots, "default"),
      o(n) === "bold" ? (t(), l("g", Z, a[0] || (a[0] = [
        e("path", { d: "M208.49,64.49l-144,144a12,12,0,0,1-17-17l144-144a12,12,0,0,1,17,17ZM60,112a12,12,0,0,0,24,0V84h28a12,12,0,0,0,0-24H84V32a12,12,0,0,0-24,0V60H32a12,12,0,0,0,0,24H60Zm164,60H144a12,12,0,0,0,0,24h80a12,12,0,0,0,0-24Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (t(), l("g", h, a[1] || (a[1] = [
        e("path", {
          d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M205.66,61.66l-144,144a8,8,0,0,1-11.32-11.32l144-144a8,8,0,0,1,11.32,11.32ZM64,112a8,8,0,0,0,16,0V80h32a8,8,0,0,0,0-16H80V32a8,8,0,0,0-16,0V64H32a8,8,0,0,0,0,16H64Zm160,64H144a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : o(n) === "fill" ? (t(), l("g", g, a[2] || (a[2] = [
        e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM56,96a8,8,0,0,1,8-8H80V72a8,8,0,0,1,16,0V88h16a8,8,0,0,1,0,16H96v16a8,8,0,0,1-16,0V104H64A8,8,0,0,1,56,96Zm24,96a8,8,0,0,1-5.66-13.66l96-96a8,8,0,0,1,11.32,11.32l-96,96A8,8,0,0,1,80,192Zm112-8H144a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Z" }, null, -1)
      ]))) : o(n) === "light" ? (t(), l("g", M, a[3] || (a[3] = [
        e("path", { d: "M204.24,60.24l-144,144a6,6,0,0,1-8.48-8.48l144-144a6,6,0,0,1,8.48,8.48ZM66,112a6,6,0,0,0,12,0V78h34a6,6,0,0,0,0-12H78V32a6,6,0,0,0-12,0V66H32a6,6,0,0,0,0,12H66Zm158,66H144a6,6,0,0,0,0,12h80a6,6,0,0,0,0-12Z" }, null, -1)
      ]))) : o(n) === "regular" ? (t(), l("g", f, a[4] || (a[4] = [
        e("path", { d: "M205.66,61.66l-144,144a8,8,0,0,1-11.32-11.32l144-144a8,8,0,0,1,11.32,11.32ZM64,112a8,8,0,0,0,16,0V80h32a8,8,0,0,0,0-16H80V32a8,8,0,0,0-16,0V64H32a8,8,0,0,0,0,16H64Zm160,64H144a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : o(n) === "thin" ? (t(), l("g", k, a[5] || (a[5] = [
        e("path", { d: "M202.83,58.83l-144,144a4,4,0,0,1-5.66-5.66l144-144a4,4,0,1,1,5.66,5.66ZM68,112a4,4,0,0,0,8,0V76h36a4,4,0,0,0,0-8H76V32a4,4,0,0,0-8,0V68H32a4,4,0,0,0,0,8H68Zm156,68H144a4,4,0,0,0,0,8h80a4,4,0,0,0,0-8Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  A as default
};
